import {voucherApi} from "../../../api/category/voucherApi";
import {IAccVoucherVm} from "../../../model/respone/category/IAccVoucher";
import {IBaseRespone} from "../../../model/respone/IBaseRespone";
import {rootActions} from "../../actions/rootActions";
import {eAccVoucherActionIds, IAccVoucherActionTypes,} from "./../../action-types/category/IAccVoucherActions";
import {call, put, takeEvery, takeLatest} from "redux-saga/effects";

export function* voucherSaga(): any {
    yield takeLatest(eAccVoucherActionIds.LOAD_START, loadWorker);
    yield takeEvery(eAccVoucherActionIds.SAVE_START, saveWorker);
    yield takeEvery(eAccVoucherActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eAccVoucherActionIds.DELETE_MANY_START, deleteManyWorker);
    yield takeEvery(
        eAccVoucherActionIds.CHECK_VOUCHER_CHANGE_START,
        checkVoucherChangeWorker
    );
}

function* loadWorker(): any {
    const res: IBaseRespone = yield call(voucherApi.SelectAllVm);
    if (res.is_success) {
        yield put(rootActions.category.voucher.LOAD_SUCCESS(res.data));
    } else {
        yield put(rootActions.category.voucher.LOAD_ERRR(res.message ?? "Có lỗi"));
    }
}

function* saveWorker(action: IAccVoucherActionTypes): any {
    let res: IBaseRespone;
    const payload = action.payload as IAccVoucherVm;
    if (payload.id > 0) {
        res = yield call(voucherApi.Update, payload);
    } else {
        res = yield call(voucherApi.Insert, payload);
    }
    if (res) {
        if (res.is_success) {
            yield put(rootActions.category.voucher.SAVE_SUCCESS(res.data));
        } else {
            yield put(
                rootActions.category.voucher.SAVE_ERROR(res.message ?? "Có lỗi")
            );
        }
    }
}

function* deleteWorker(action: IAccVoucherActionTypes): any {
    const res: IBaseRespone = yield call(
        voucherApi.Delete,
        action.payload as number
    );
    if (res.is_success) {
        yield put(rootActions.category.voucher.DELETE_SUCCESS(res.data));
    } else {
        yield put(
            rootActions.category.voucher.DELETE_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* deleteManyWorker(action: IAccVoucherActionTypes): any {
    const res: number = yield call(
        voucherApi.DeleteMany,
        action.payload as number[]
    );
    if (res > 0) {
        yield put(rootActions.category.voucher.DELETE_MANY_SUCCESS(undefined));
    } else {
        yield put(rootActions.category.voucher.DELETE_MANY_ERROR("Có lỗi"));
    }
}

function* checkVoucherChangeWorker(action: IAccVoucherActionTypes): any {
    const res: IBaseRespone = yield call(
        voucherApi.CheckChange,
        action.payload as IAccVoucherVm
    );
    if (res.is_success) {
        yield put(
            rootActions.category.voucher.CHECK_VOUCHER_CHANGE_SUCCESS(res.data)
        );
    } else {
        yield put(
            rootActions.category.voucher.CHECK_VOUCHER_CHANGE_ERROR("Có lỗi")
        );
    }
}
